import React from "react";

const DARK = { backgroundColor: "#2D181E", backgroundImage: "radial-gradient(circle at 100% 0%, rgba(123,17,58,0.55), transparent 60%)" };
const num = (v) => parseFloat(String(v || "").replace(/\s/g, "").replace(",", ".").replace(/[^\d.]/g, "")) || 0;
const eur = (v) => `${Math.round(v).toLocaleString("fr-FR")} €`;

function computeStats(items) {
  const closed = items.filter((i) => i.outcome === "close");
  const lost = items.filter((i) => i.outcome === "pas_close");
  const pending = items.filter((i) => i.outcome === "en_attente");
  const decided = closed.length + lost.length;
  const ca = closed.reduce((s, i) => s + num(i.amount), 0);
  const d = new Date();
  const month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  return {
    total: items.length,
    closed: closed.length, lost: lost.length, pending: pending.length,
    rate: decided ? Math.round((closed.length / decided) * 100) : 0,
    ca,
    pipeline: pending.reduce((s, i) => s + num(i.amount), 0),
    thisMonth: items.filter((i) => (i.call_date || "").startsWith(month)).length,
    feedbacks: items.filter((i) => i.feedback).length,
  };
}

const Tile = ({ label, value, sub, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-line bg-white p-4 shadow-card sm:p-5">
    <p className="font-sans text-2xl font-medium text-ink">{value}</p>
    <p className="mt-1 text-sm font-medium text-ink">{label}</p>
    {sub && <p className="text-xs font-light text-ink-muted">{sub}</p>}
  </div>
);

export function ClosingDashboard({ items }) {
  const s = computeStats(items);
  return (
    <div data-testid="closing-dashboard" className="space-y-3">
      <div className="flex flex-col gap-5 rounded-[24px] p-5 text-white shadow-[0_16px_48px_rgba(45,24,30,0.22)] sm:flex-row sm:items-center sm:p-6" style={DARK}>
        <div className="flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#F3D2D9]">Taux de closing</p>
          <p data-testid="closing-rate" className="mt-1 font-sans text-4xl font-medium">{s.rate}%</p>
          <p className="mt-1 text-xs font-light text-white/60">Appels closés sur les appels avec une décision (hors « en attente »)</p>
        </div>
        <div className="grid grid-cols-3 gap-2 sm:w-72">
          {[["Closés", s.closed, "closing-count-close"], ["Pas closés", s.lost, "closing-count-lost"], ["En attente", s.pending, "closing-count-pending"]].map(([l, v, t]) => (
            <div key={l} data-testid={t} className="rounded-2xl bg-white/5 p-3 text-center ring-1 ring-white/10">
              <p className="font-sans text-lg font-medium">{v}</p>
              <p className="text-[11px] text-white/60">{l}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3 min-[420px]:grid-cols-2">
        <Tile testid="closing-total" label="Appels réalisés" value={s.total} sub={`${s.thisMonth} ce mois-ci`} />
        <Tile testid="closing-ca" label="CA signé" value={eur(s.ca)} sub="Somme des appels closés" />
        <Tile testid="closing-pipeline" label="En attente de réponse" value={eur(s.pipeline)} sub="CA potentiel à relancer" />
        <Tile testid="closing-feedbacks" label="Feedbacks reçus" value={`${s.feedbacks} / ${s.total}`} sub="Appels analysés par Fanny" />
      </div>
    </div>
  );
}
